import * as THREE from 'three/webgpu';
import type { PointSelectionCandidate } from '../../reference/reference-point/ReferencePointController';
import { SketchEntitiesTransformSelectionRole } from '../../sketch/entities-transform';
import type { RawPointerEventPayload } from '../../viewer/moudles/EventManager';
import type { EntitySelectionManager } from '../EntitySelectionManager';
import { AbstractSketchEntitiesTransformSelectionHandler } from './AbstractSketchEntitiesTransformSelectionHandler';

/**
 * 移动实体命令选择处理器。
 */
export class SketchMoveEntitiesSelectionHandler extends AbstractSketchEntitiesTransformSelectionHandler {
	/**
	 * @param entitySelectionManager 实体选择管理器。
	 */
	public constructor(entitySelectionManager: EntitySelectionManager) {
		super(entitySelectionManager);
	}

	
	public override onMouseMove(payload: RawPointerEventPayload): void {
		const controller = this.entitySelectionManager.renderer.sketchMoveEntitiesController;
		if (controller?.handlePointerDrivenPreviewMove(payload.clientX, payload.clientY)) {
			payload.nativeEvent.preventDefault();
			return;
		}
		super.onMouseMove(payload);
	}

	
	public override onClick(payload: RawPointerEventPayload): void {
		if (payload.button !== 0) {
			return;
		}

		const controller = this.entitySelectionManager.renderer.sketchMoveEntitiesController;
		const snapshot = controller?.getSnapshot();
		if (
			controller?.isPointerDrivenPreviewActive()
			&& snapshot?.activeSelectionRole === SketchEntitiesTransformSelectionRole.None
		) {
			controller.handlePointerDrivenPreviewPlacement();
			return;
		}

		super.onClick(payload);
	}

	
	protected resolveSelectionRole(): SketchEntitiesTransformSelectionRole {
		return this.entitySelectionManager.renderer.sketchMoveEntitiesController?.getSnapshot().activeSelectionRole
			?? SketchEntitiesTransformSelectionRole.Entities;
	}

	
	protected handleEntityPicked(object: THREE.Object3D): void {
		this.entitySelectionManager.renderer.sketchMoveEntitiesController?.handleEntityPick(object);
	}

	//------ 草图实体变换框选 开始------
	/**
	 * 处理移动实体命令的框选结果。
	 *
	 * @param objects 框选命中的原始对象集合。
	 */
	protected handleEntitiesBoxSelected(objects: readonly THREE.Object3D[]): void {
		this.entitySelectionManager.renderer.sketchMoveEntitiesController?.handleEntityBoxSelection(objects);
	}
	//------ 草图实体变换框选 结束------

	
	protected handleReferenceCandidate(candidate: PointSelectionCandidate): void {
		this.entitySelectionManager.renderer.sketchMoveEntitiesController?.handleReferencePointSelection(candidate);
	}
}
